import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { QuestionnaireSummary } from "@/Modules/Models/Domain/Questionnaire";
import type { QuestionnaireSummaryApi } from "@/Modules/Models/Api/Questionnaire";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";
import { unixSecondsToDate } from "@/Utils/Date";

const QuestionnaireSummaryTransformer: TransformerExtended<QuestionnaireSummary, QuestionnaireSummaryApi> = {
  ...DefaultTransformerGenerator<QuestionnaireSummary, QuestionnaireSummaryApi>(),

  toDomain(value: QuestionnaireSummaryApi): QuestionnaireSummary {
    const questionnaireSummary = camelize<QuestionnaireSummaryApi, QuestionnaireSummary>(
      value,
      ["uuid", "completed", "questionnaire_uuid", "updated", "created", "type", "render_url", "visible"],
      ["id", "isCompleted", "questionnaireId", "updatedAt", "createdAt"]
    ) as Omit<QuestionnaireSummary, "createdAt">;

    return {
      ...questionnaireSummary,
      createdAt: unixSecondsToDate(value.created),
      updatedAt: value.updated ? unixSecondsToDate(value.updated) : null,
    };
  },
};

export type QuestionnaireSummaryTransformerType = TransformerExtended<
  QuestionnaireSummary,
  QuestionnaireSummaryApi
>;

export default QuestionnaireSummaryTransformer;
